import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./contact.css";
import BeforeFooter from "../components/layout/BeforeFooter";
import profilePlaceholder from "../assets/message.png";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaMedium } from "react-icons/fa6";
import { API_URL } from '../config/api';

function Contact() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    setStatusType("loading");
    try {
      const response = await fetch(`${API_URL}/contact/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      if (data.success) {
        setStatus("Message sent successfully!");
        setStatusType("success");
        setForm({ name: "", email: "", message: "" });
        setSubmitted(true);
      } else {
        setStatus("Failed to send message.");
        setStatusType("error");
      }
    } catch (error) {
      console.error(error);
      setStatus("Error sending message.");
      setStatusType("error");
    }

    if (statusType === "error") {
      setTimeout(() => {
        setStatus("");
        setStatusType("");
      }, 5000);
    }
  };

  return (
    <>
      <section className="contact-hero">
        <div className="contact-container" data-aos="fade-up">
          <div className="contact-header">
            <div className="contact-avatar">
              <img src={profilePlaceholder} alt="Contact" />
            </div>
            <div>
              <h2>Contact me</h2>
              <p className="contact-subtitle">I'd love to hear from you ✨</p>
            </div>
          </div>

          {!submitted ? (
            <form className="contact-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Your name"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your email"
                value={form.email}
                onChange={handleChange}
                required
              />
              <textarea
                name="message"
                placeholder="Your message"
                rows="5"
                value={form.message}
                onChange={handleChange}
                required
              />
              <button type="submit" disabled={statusType === "loading"}>
                {statusType === "loading" ? "Sending..." : "Send message"}
              </button>
              {status && statusType === "error" && (
                <p className={`status-message ${statusType}`}>{status}</p>
              )}
            </form>
          ) : (
            <div className="contact-success">
              <span className="success-emoji">🌸</span>
              <h3>Message received!</h3>
              <p>Thank you for reaching out. I'll get back to you soon.</p>
            </div>
          )}

          {/* Social Links */}
          <div className="contact-socials">
            <p className="socials-label">Or find me on</p>
            <div className="socials-row">
              <a href="https://www.instagram.com/elbylit" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaInstagram /> Instagram
              </a>
              <a href="https://www.linkedin.com/in/loubna-bouzenzen-86a6441b8/" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaLinkedin /> LinkedIn
              </a>
              <a href="https://medium.com/@Loubna-DS" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaMedium /> Medium
              </a>
            </div>
          </div>

        </div>
      </section>
      <BeforeFooter />
    </>
  );
}

export default Contact;